import React from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';
import { ButtonTagsForm } from '../../../editor/features/build/components/widgets/buttons/ButtonConfigform/ButtonTagsForm';
import TagModel from '@mm/state/model/TagModel';
import { TagsWidgetConfig, WidgetBase } from '@mm/state/model/WidgetModel';
import { useTagsWidgetHandlers } from '../../helpers/widget-helpers/use-tags-widget-handlers';
import { WidgetControls } from '../common/WidetControls/WidgetControls';
import './TagsWidget.pcss';
import { WidgetContainerRefProp } from '../../../editor/features/startBotPromoters/common/StartBotsDialogueEditor/WidgetByType/WidgetByType';
import { PlatformType } from '@mm/state/model/CampaignsModel';

type Props = {
  widget: WidgetBase<TagsWidgetConfig>;
  draggableProvided?: DraggableProvided;
  platforms?: PlatformType[];
} & WidgetContainerRefProp;

export const TagsWidget = (props: Props) => {
  const { widget, draggableProvided, platforms } = props;
  const tagsWidgetHandlers = useTagsWidgetHandlers();
  const tags = widget.config.tags || [];
  const kind = widget.config.kind || 'add';

  const onUpdate = (tags: TagModel[], kind: TagsWidgetConfig['kind']) => {
    const changedWidget = {
      ...widget,
      config: {
        tags,
        kind,
      },
    };
    // Note: our current widget type system is not sophisticated enough to figure it out correctly
    tagsWidgetHandlers.update(changedWidget as any);
  };

  const onAdd = (tag: TagModel) => {
    if (widget.config.kind) {
      onUpdate([tag].concat(tags), widget.config.kind);
    }
  };

  const onRemove = (tag: TagModel) => {
    if (widget.config.kind) {
      onUpdate(
        tags.filter(
          (tagItem: TagModel) =>
            !(tagItem.name === tag.name && tagItem.kind === tag.kind),
        ),
        widget.config.kind,
      );
    }
  };

  const onChangeKind = (kind: TagsWidgetConfig['kind']) => {
    onUpdate(tags, kind);
  };

  // Note: widget types are not good enough
  return (
    <div className="tags-widget">
      <ButtonTagsForm
        title="Add or remove tags from contacts who get to this point in dialog."
        tags={tags}
        kind={kind}
        isOpen
        onChangeKind={onChangeKind}
        onTagAdd={onAdd}
        onTagRemove={onRemove}
      />
      <WidgetControls
        widget={widget as any}
        draggableProvided={draggableProvided}
        platforms={platforms}
      />
    </div>
  );
};
